import { call, put, all, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { getUserFranchises } from 'services/openClaimService';
import { ApiResponse } from 'types/ApiResponse';
import { setStoreList } from './actions';
import { STORES_TYPES } from './types';

export function* setStoreListSaga() {
  try {
    const { data }: AxiosResponse<ApiResponse<any>> = yield call(
      getUserFranchises,
    );
    yield put(setStoreList(data.response.stores));
  } catch (err) {
    console.log(err);
  }
}

export default all([
  takeLatest(STORES_TYPES.GET_STORELIST_REQUEST, setStoreListSaga),
]);
